/**
 * initializeViewport.js — ビューポート制御
 *
 * 画面幅が最小幅（360px）未満の場合に viewport を固定幅に切り替え、
 * 超小型端末でのレイアウト崩れを防止する。
 */

function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}

export function initializeViewport() {
  const handleResize = () => {
    const minWidth = 375;
    const value =
      screen.width > minWidth
        ? "width=device-width,initial-scale=1"
        : `width=${minWidth}`;
    const viewport = document.querySelector('meta[name="viewport"]');
    if (viewport && viewport.getAttribute("content") !== value) {
      viewport.setAttribute("content", value);
    }
  };

  const debouncedResize = debounce(handleResize, 250);

  window.addEventListener("resize", debouncedResize);
  handleResize();
}
